import React, { useEffect, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { unstake } from '../../httpcalls/contractThunk';
import { Center } from '@mantine/core';
import Tilt from 'react-parallax-tilt';


const B_Staked = (props) => {
    const dispatch = useDispatch();

    const epoch = useSelector(state => state.mainapp.stakingSlice.epoch)
    const stakingEarnedAmount = useSelector((state) => state.mainapp.stakingSlice.earnings)
    const stakedAt = useSelector((state) => state.mainapp.stakingSlice.stakingTime)
    const userIndex = useSelector((state) => state.mainapp.stakingSlice.userIndex)




    return (
        <>
            <div className='logo-card'>

                <img className='logo-stencil' src={'../../../assets/logo.png'}></img>
                <div className='logo-strip'>
                    <img src={'../../../assets/logo.png'}></img>
                </div>
                <div className='logo-activity-strip'>
                    <div className='logo-activity-left'>
                        <p>Staked Account</p>
                        <h2>21,000</h2>
                    </div>
                    <div className='logo-activity-right'>
                        <div className='charm-price'>

                            <div className='charm-price-text'>
                                <p>Total Rewards</p>
                                <h2>{
                                    // format to currency using to locale string
                                    stakingEarnedAmount.toFixed(2)
                                }</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default B_Staked;
